module.exports = __webpack_public_path__ + "img/recycle-bin.35b98769.svg";